module.exports = __webpack_public_path__ + "d00af408f815cdacdb185e1aa843ceb1.pdf";